<template>
    <div class="messages">
        <div class="message success" :class="{show:showSuccess}">
            <font-awesome-icon icon="times" @click="closeMessage('success')"/>
            <font-awesome-icon icon="check-circle" class="indicator"/>
            <div class="message-inner">
                <span v-if="messages.success.length == 1" v-html="messages.success[0].message"></span>
                <ul v-if="messages.success.length > 1">
                    <li v-for="message in messages.success" v-html="message.message"></li>
                </ul>
            </div>
        </div>
        <div class="message error" :class="{show:showError}">
            <font-awesome-icon icon="times" @click="closeMessage('error')"/>
            <font-awesome-icon icon="exclamation-circle" class="indicator"/>
            <div class="message-inner">
                <span v-if="messages.error.length == 1" v-html="messages.error[0].message"></span>
                <ul v-if="messages.error.length > 1">
                    <li v-for="message in messages.error" v-html="message.message"></li>
                </ul>
            </div>
        </div>
        <div class="message info" :class="{show:showInfo}">
            <font-awesome-icon icon="times" @click="closeMessage('info')"/>
            <font-awesome-icon icon="info-circle" class="indicator"/>
            <div class="message-inner">
                <span v-if="messages.info.length == 1" v-html="messages.info[0].message"></span>
                <ul v-if="messages.info.length > 1">
                    <li v-for="message in messages.info" v-html="message.message"></li>
                </ul>
            </div>
        </div>
        <div class="message warning" :class="{show:showWarning}">
            <font-awesome-icon icon="times" @click="closeMessage('warning')"/>
            <font-awesome-icon icon="question-circle" class="indicator"/>
            <div class="message-inner">
                <span v-if="messages.warning.length == 1" v-html="messages.warning[0].message"></span>
                <ul v-if="messages.warning.length > 1">
                    <li v-for="message in messages.warning" v-html="message.message"></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'messages',
        components: {
        },
        props: [],
        data: () => ({
            /*messages: {
                success: [],
                error:[],
                info: []
            }*/
        }),
        computed: {
            ...mapGetters({
                messages: 'Messages/messages'
            }),
            showMessages: function(){
                return this.messages.success.length > 0 || this.messages.error.length > 0 || this.messages.info.length > 0;
            },
            showSuccess: function(){
                return this.messages.success.length > 0;
            },
            showError: function(){
                return this.messages.error.length > 0;
            },
            showInfo: function(){
                return this.messages.info.length > 0;
            },
            showWarning: function(){
                return this.messages.warning.length > 0;
            }
        },
        methods: {
            sendMessage: function(type,message){

                if(Object.prototype.toString.call( message ) !== Object.prototype.toString.call( [] ))
                    message = [message];

                for(var i = 0; i < message.length; i++)
                {
                    var messageIndex = this.checkMessageExists(type,message[i]);
                    if(messageIndex === false){
                        this.messages[type].push({message:message[i],count:window.V._router.routeCount});
                    }
                }

            },
            checkMessageExists:function(type,message){
                for(var i = 0; i < this.messages[type].length; i++){
                    if(this.messages[type][i].message == message){
                        return i;
                    }
                }
                return false;
            },
            closeMessage: function(type){
                this.messages[type] = [];
            },
            clearMessages: function(){
                this.closeMessage('success');
                this.closeMessage('error');
                this.closeMessage('info');
            },
            checkCountsForAutoDisappear: function(){
                this.checkMessageCount('success');
                this.checkMessageCount('error');
                this.checkMessageCount('info');
            },
            checkMessageCount: function(type){

                var count = window.V._router.routeCount;

                for(var i = 0; i < this.messages[type].length; i++){
                    if(this.messages[type][i].count == count - 3){
                        this.messages[type].splice(i,1);
                    }
                }
            }
        }
    }
</script>

<style lang="scss">

    $messages-button-height: 50px;

    .messages{



        left: 0px;
        margin: 0 0;
        position: absolute;
        right: 0px;
        top: 0;
        z-index: 100000000000000000;

        .message{
            border-top: 0;
            color: $main-white;
            font-weight: $medium;
            height: 0;
            overflow: hidden;
            padding: 0;
            position: relative;
            transition-property: border, height, padding;

            &.success{
                background-color: $success;
            }
            &.error{
                background-color: $error;
            }
            &.info{
                background-color: $info;
            }
            &.warning{
                background-color: $warning;
            }
            &.show{
                border-top: solid 3px rgba(0,0,0,0.2);
                height: auto;
                padding: 20px 0;
            }

            .indicator{
                color: rgba(0,0,0,0.1);
                font-size: 4rem;
                left: -30px;
                line-height: $messages-button-height;
                margin-top: - $messages-button-height/2;
                position: absolute;
                text-align: center;
                top: 50%;
                transform: rotate(-30deg);
                vertical-align: middle;
                width: $messages-button-height*2;
            }

            .fa-times{
                cursor: pointer;
                font-size: 1.5rem;
                line-height: $messages-button-height;
                position: absolute;
                right: 0px;
                text-align: center;
                top: $messages-button-height/3;
                width: $messages-button-height;
            }

            .message-inner{
                padding: 0 $messages-button-height 0 $messages-button-height*1.5;

                ul{
                    list-style-type: square;
                    margin: 0;
                    padding-left: 20px;
                }
            }
        }


    }

</style>



// WEBPACK FOOTER //
// src/components/ui/Messages.vue